import "./styles.css";
import Effect from "./pages/home/page";

export type LightingRiverHeroProps = Record<string, never>;

export function LightingRiverHero(_props: LightingRiverHeroProps = {}) {
  return (
    <div className="special-effect-root" data-special-effect="lighting-river">
      <Effect />
    </div>
  );
}

export default LightingRiverHero;
